export default __webpack_public_path__ + "static/media/car.70daad80.png";